import {
    AppstoreOutlined,
    CustomerServiceOutlined,
    MessageOutlined,
    NotificationOutlined,
    ProfileOutlined,
    GlobalOutlined,
    SafetyCertificateOutlined,
    DeleteOutlined,
    ExperimentOutlined,
    DashboardOutlined,
    ClockCircleOutlined
} from '@ant-design/icons';

export const roleMenuItems = {
    ADMIN: [
        {
            key: 'dashboard',
            icon: <AppstoreOutlined/>,
            path: '/dashboard/admin-home',
            label: 'dashboard.dashboard',
            children: []
        },
        {
            key: 'history-chats',
            path: '/dashboard/history/chats',
            label: 'dashboard.history_chat',
            icon: <MessageOutlined/>,
            children: []
        },
        {
            key: 'manage-operators',
            path: '/dashboard/operators',
            label: 'dashboard.operators',
            icon: <CustomerServiceOutlined/>,
            children: []
        },
        {
            key: 'shifts',
            path: '/dashboard/shifts',
            label: 'dashboard.shifts',
            icon: <ClockCircleOutlined/>,
            children: []
        },
        // «چت‌ها» یک ابزار اپراتوری است: لیست آن فقط از STOMP می‌آید و بک‌اند کاربر را با
        // operatorRepository.findByEmail پیدا می‌کند، پس ادمین (که رکورد Operator ندارد) هیچ‌وقت
        // چیزی دریافت نمی‌کرد و صفحه همیشه خالی بود. ادمین از «تاریخچه چت‌ها» بالا استفاده کند
        // که روی REST کار می‌کند و به ترنسکریپت هم لینک می‌دهد.
        // {
        //     key: 'manage-operators-status',
        //     path: '/dashboard/operators/status',
        //     label: 'dashboard.operators_status',
        //     icon: <PoweroffOutlined/>,
        //     children: []
        // },
        {
            key: 'widget-settings',
            path: '/dashboard/settings/widget',
            label: 'dashboard.widget_settings',
            icon: <GlobalOutlined/>,
            children: []
        },
        {
            key: 'system-health',
            path: '/dashboard/system-health',
            label: 'dashboard.system_health',
            icon: <DashboardOutlined/>,
            children: []
        },
        {
            key: 'feature-flags',
            path: '/dashboard/feature-flags',
            label: 'dashboard.feature_flags',
            icon: <ExperimentOutlined/>,
            children: []
        },
        {
            key: 'deleted-items',
            path: '/dashboard/deleted-items',
            label: 'dashboard.deleted_items',
            icon: <DeleteOutlined/>,
            children: []
        },
        {
            key: 'audit-log',
            path: '/dashboard/audit-log',
            label: 'dashboard.audit_log',
            icon: <SafetyCertificateOutlined/>,
            children: []
        },
        {
            key: 'settings-profile',
            path: '/dashboard/settings/profile',
            label: 'dashboard.profile',
            icon: <ProfileOutlined/> // پروفایل
        },
    ],
    /**
     * The supervisor's desk.
     *
     * <p>Watching and steering conversations — the live board, the archive, their own account — plus
     * the shift rota, which decides who receives work and is the one operator-facing thing they may
     * change. Still nothing that configures the product: no widget settings, no creating or deleting
     * operators, no passwords, no feature flags, no deletion. That boundary is the reason the role
     * exists, it is enforced on the backend, and this menu only avoids showing doors that answer 403.
     */
    SUPERVISOR: [
        {
            key: 'chats',
            path: '/dashboard/chats',
            label: 'dashboard.chat',
            icon: <MessageOutlined/>,
            children: []
        },
        {
            key: 'history-chats',
            path: '/dashboard/history/chats',
            label: 'dashboard.history_chat',
            icon: <CustomerServiceOutlined/>,
            children: []
        },
        {
            key: 'shifts',
            path: '/dashboard/shifts',
            label: 'dashboard.shifts',
            icon: <ClockCircleOutlined/>,
            children: []
        },
        {
            key: 'settings-profile',
            path: '/dashboard/settings/profile',
            label: 'dashboard.profile',
            icon: <ProfileOutlined/>
        },
    ],
    OPERATOR: [
        {
            key: 'dashboard',
            icon: <AppstoreOutlined/>,
            path: '/dashboard/operator-home',
            label: 'dashboard.dashboard',
            children: []
        },
        {
            key: 'chats',
            path: '/dashboard/chats',
            label: 'dashboard.chat',
            icon: <MessageOutlined/>,
            children: []
        },
        {
            key: 'notifications',
            icon: <NotificationOutlined/>,
            path: '/dashboard/notifications',
            label: 'dashboard.notifications',
            children: []
        },
        {
            key: 'settings-profile',
            path: '/dashboard/settings/profile',
            label: 'dashboard.profile',
            icon: <ProfileOutlined/>
        },
    ]

};
